'use strict';
import DetailsView from '../../../Pandora/model/details-view';
import EditFormCtrl from './edit-form';
import template from './edit-form.html';

/**
 * @ngdoc Class
 * @name EditFormView
 *
 * @description
 * View of edit-form tab
 *
 * @param {Object} options - attributes of view
 *
 */
export default class EditFormView extends DetailsView {
	constructor(i18n, options) {
		const headerTitle = i18n.get(options.isAddingNew ? 'solutionBuilderAgent.common.add_new' : 'solutionBuilderAgent.common.edit');

		options = angular.extend({}, options, {
			controller: EditFormCtrl,
			template: template,
			id: 'edit-form-' + Date.now(),
			headerTitle: headerTitle,
			displayName: options.displayName || '',
			name: options.displayName || '',
			keepAsOpened: true,
		});
		super(options);
	}
}
